import { render, staticRenderFns } from "./ReferralForm.vue?vue&type=template&id=9da35038&scoped=true&"
import script from "./ReferralForm.vue?vue&type=script&lang=js&"
export * from "./ReferralForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferralForm.vue?vue&type=style&index=0&id=9da35038&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da35038",
  null
  
)

export default component.exports